import { createSlice } from '@reduxjs/toolkit';
import { getCommonData } from "../../../rtk-apis/common/getCommonData"

const initialState = {
  status: '',
  result: '',
  msg: '',
  loading: false,
};

const getCommonDataSlice = createSlice({
  name: 'getCommonDataSlice',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getCommonData.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getCommonData.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.result = action?.payload?.data;
      })
      .addCase(getCommonData.rejected, (state, { payload }) => {
        state.loading = false;
        state.status = 'FAILED';
        state.msg = payload as string;
      });
  },
});

export const { clearState } = getCommonDataSlice.actions;
export default getCommonDataSlice.reducer;
